import { Box, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { UserContext, UserContextPayload } from '../../context/userContext';
import { useNavigate } from 'react-router-dom';
import profileIcon from "../../assets/profileIcon.svg";
import Logout from '@mui/icons-material/Logout';
import styles from "../../assets/styles/componentStyles/sidePanelAccountDetails.module.scss";
import globalStyles from "../../assets/styles/global.module.scss";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import agent from '../../services/api';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import GlobalButton from './globalButton/button';
import { CallAnalysisContext, CallAnalysisContextPayload } from '../../context/callAnalysisContext';
import { disConnectSocket } from '../../utils/socketIo';
import KeyIcon from '@mui/icons-material/Key';
import IconsColor from './iconsColor';
import { blackColor } from '../../utils/colors';
import { globalMenuItemData } from '../../models/axiosModel';
import { hasApiKeyPageAccess, hasBillingUsageManageAccess } from '../../utils/constants';
import GlobalMenu from '../globalMenu';
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface SidepanelAccountDetailsProps {
    flagMobile?: boolean,
    onClose?: () => void,
}

interface accountMenuItems {
    label: string,
    icon: JSX.Element,
    onClick: () => void,
}

export const SidepanelAccountDetails = (props: SidepanelAccountDetailsProps) => {
    const navigate = useNavigate();
    const { callRecordsData } = useContext(CallAnalysisContext) as CallAnalysisContextPayload
    const { handleError, userDetail, vendorData, setFlagLoading, setUserDetail, flagLoading, resetOrganizationContext, setFlagOnboardingSkip, setFlagUpdateUserDetailPopup, setFlagViewUserDetailPopup, organizationDetails, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const [openMenu, setOpenMenu] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    let urlToNavigateTo = encodeURIComponent(window.location.href)

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
        setOpenMenu(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpenMenu(false);
        props?.onClose?.();
    };

    const onClickOfProfileMenuItem = () => {
        setFlagUpdateUserDetailPopup(true);
        setFlagViewUserDetailPopup(true);
        props?.onClose?.();
    }

    const onClickOfLogOutMenuItem = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true, flagFullScreenLoader: true });;
        const response = await agent.LogoutAPI.post();
        if (response.status) {
            setFlagOnboardingSkip(null)
            // resetOrganizationContext()
            // localStorage.removeItem('writeWizUserDetail');
            // setUserDetail({ ...userDetail, flagUser: false });
            // navigate("/login")
            // navigate("/login", { replace: true });
            disConnectSocket();
            window.location.href = "/login";

            // window.location.href = "https://google.com";
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false, flagFullScreenLoader: false });
        props?.onClose?.();
    }

    const onClickOfApiKeysMenuItem = () => {
        navigate('/apiKeys');
        props?.onClose?.();
    }

    const onClickOfOrganizationMenuItem = () => {
        if (!organizationDetails) {
            navigate('/');
        }
        else if (organizationDetails && organizationDetails.length > 1) {
            navigate('/organization')
        } else {
            navigate(`/organization?organization_id=${organizationDetails ? organizationDetails[0].organization_id : ""}`)
        }
        props?.onClose?.();
    }

    const onClickOfSignInMenuItem = () => {
        navigate("/login?redirect=" + urlToNavigateTo);
    }

    const onClickOfBillingUsageMenuItem = () => {
        navigate('/billing-usage');
        props?.onClose?.();
    }

    const accountMenuItemsData: globalMenuItemData[] = [
        {
            type: "group",
            label: "ACCOUNT",
            children: [
                {
                    type: "item",
                    label: "Profile",
                    icon: <PermIdentityIcon fontSize="small" />,
                    onClick: () => onClickOfProfileMenuItem(),
                },
                {
                    type: "item",
                    label: "Workspace",
                    icon: <IconsColor height={"18"} width={"18"} fillColor={blackColor} iconName="workspace" />,
                    onClick: () => onClickOfOrganizationMenuItem(),
                },
                ...(hasBillingUsageManageAccess(apiRoutesPermissionAssignment, userDetail, vendorData) ? [
                    {
                        type: "item" as const,
                        label: "Billing & Usage",
                        icon: <IconsColor height={"18"} width={"18"} fillColor={blackColor} iconName="billing" />,
                        onClick: () => onClickOfBillingUsageMenuItem(),
                    }
                ] : []),
            ]
        },
        {
            type: "divider"
        },
        ...(hasApiKeyPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            {
                type: "group",
                label: "DEVELOPER",
                children: [
                    {
                        type: "item",
                        label: "API Keys",
                        icon: <KeyIcon fontSize="small" />,
                        onClick: () => onClickOfApiKeysMenuItem(),
                    }
                ]
            },
            {
                type: "divider"
            },
        ] as globalMenuItemData[] : []),
        {
            type: "item",
            label: "Logout",
            icon: <Logout fontSize="small" />,
            onClick: () => onClickOfLogOutMenuItem()
        }
    ]

    const accountMenuItemsDataForAnonymousUser: globalMenuItemData[] = [
        {
            type: "item",
            label: "Sign In/ Register",
            icon: <AppRegistrationIcon fontSize="small" />,
            onClick: () => onClickOfSignInMenuItem()
        }
    ]

    return (
        <>
            <GlobalMenu
                anchorEl={anchorEl}
                handleMenuClose={handleClose}
                menuItemData={(!userDetail.flag_user_anonymous && userDetail.flagUser) ? accountMenuItemsData : accountMenuItemsDataForAnonymousUser}
                open={openMenu}
                transformOrigin={{ horizontal: 'left', vertical: 'center' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                className={globalStyles.aboveGlobalLoader}
            />
            {userDetail.flagUser && !userDetail.flag_user_anonymous ?
                <Box className={props.flagMobile ? `${styles.mainBlockMobile}` : `${styles.mainBlock} ${styles.AccountDetailsWrapper}`}
                    // onClick={props.flagMobile ? handleClick : undefined}
                    onClick={handleClick}
                    aria-controls={openMenu ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                >
                    <Box className={globalStyles.displayFlex}>
                        <img alt="" src={profileIcon} className={styles.profilestyles} />
                        {!props.flagMobile &&
                            <Typography className={`${styles.nameStyle} ${styles.menuNameEllipsis}`}>
                                {userDetail.flag_user_anonymous ? "Anonymous" :
                                    `${userDetail.user_first_name == null ? userDetail.user_email
                                        :
                                        `${userDetail.user_first_name} ${userDetail.user_last_name !== null ? userDetail.user_last_name : ""}`}`
                                    // `${userDetail.user_first_name} ${userDetail.user_last_name !== null ? userDetail.user_last_name : ""}`
                                }
                            </Typography>
                        }
                    </Box>
                    {!props.flagMobile &&
                        <ArrowForwardIosIcon
                            // onClick={handleClick}
                            // aria-controls={openMenu ? 'account-menu' : undefined}
                            // aria-haspopup="true"
                            // aria-expanded={openMenu ? 'true' : undefined}
                            className={styles.menuArrowIcon}
                        />
                    }
                </Box>
                :
                <>
                    {props.flagMobile ?
                        <>
                            <Box className={props.flagMobile ? styles.mainBlockMobile : styles.mainBlock}
                                onClick={props.flagMobile ? handleClick : undefined}
                            >
                                <Box className={globalStyles.displayFlex}>
                                    <img src={profileIcon} className={styles.menuProfileIcon} />
                                </Box>
                            </Box></>
                        :
                        <>
                            <GlobalButton buttonText={props.flagMobile ? <AppRegistrationIcon fontSize="small" /> : "  Sign In/ Register"} className='primaryButtonStyle' flagFullWidth onClick={() => { navigate("/login?redirect=" + urlToNavigateTo) }} />
                        </>}
                </>
            }
        </>
    )
}
